import React, { useEffect, useContext } from "react";
import { MapContext } from "./Map";
const createMarker = (data) => {
  let marker = null;

  let create = () => {
    let markerContent = document.createElement("div");
    let markerImg = document.createElement("img");
    markerContent.classList.add(data.className);
    markerContent.setAttribute("id", data.id);
    markerImg.src = data.url;
    markerContent.appendChild(markerImg);
    marker = new window.AMap.Marker({
      // map: map,
      zIndex: data.zIndex || 10,
      content: markerContent,
      position: data.lnglat,
      offset: new window.AMap.Pixel(...data.offset),
      extData: data,
    });
  };

  let setLabel = () => {
    let content = data.label;
    marker &&
      content &&
      marker.setLabel({
        offset: new window.AMap.Pixel(...data.textOffset),
        content: `<div class="Tengits-Map-Label ${
          data.isActive ? "Tengits-Map-Label__active" : ""
        }">${content}</div>`,
        direction: data.direction,
      });
  };

  create();
  setLabel();

  return marker;
};

export default ({
  markerData,
  onClick,
  saveMarkers = () => {},
  addToMap = true,
}) => {
  const map = useContext(MapContext);
  useEffect(() => {
    if (!map || !markerData) return;
    let markers = [];
    markerData.map((d) => {
      let marker = createMarker(d);
      markers.push(marker);
      marker.on("click", () => onClick(d));
      addToMap && marker.setMap(map);
    });
    saveMarkers(markers);
    return () => {
      // todo 优化为图层
      markers.map((marker) => {
        marker.setMap(null);
      });
    };
  }, [map, markerData]);
  if (!window.AMap) return null;
  return <div className="MarkerLayout"></div>;
};
